import type { NavMode } from '@ui';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface NavState {
  /** Desktop (lg and up) side-nav state – persisted. */
  mode: NavMode;
  /** Mobile drawer – transient. */
  mobileOpen: boolean;
}

const initialState: NavState = { mode: 'expanded', mobileOpen: false };

export const navSlice = createSlice({
  name: 'nav',
  initialState,
  reducers: {
    setNavMode: (state, action: PayloadAction<NavMode>) => {
      state.mode = action.payload;
    },
    setMobileNavOpen: (state, action: PayloadAction<boolean>) => {
      state.mobileOpen = action.payload;
    },
  },
  selectors: {
    selectNavMode: (state) => state.mode,
    selectMobileNavOpen: (state) => state.mobileOpen,
  },
});

export const { setNavMode, setMobileNavOpen } = navSlice.actions;
export const { selectNavMode, selectMobileNavOpen } = navSlice.selectors;
